import {
  isDefined,
  isObject,
  isStringDefined,
  isUndefined
} from '../../../utils/isDefined';
import Optional from '../../../utils/optional';
import searchCaseInsensitive from '../../../utils/searchCaseInsensitive';

export function customSearchByProduct({ rowData, term, lang }) {
  const { name, category, subs = [], skuTranslations = {} } = rowData;

  if (
    (searchCaseInsensitive(name, term) || searchCaseInsensitive(category, term),
    searchCaseInsensitive(
      Optional(skuTranslations[lang]).or(skuTranslations.default),
      term
    ))
  ) {
    return true;
  }

  return searchInSubs(subs, term);
}

export function customSearchByProductCategory({ rowData, term }) {
  const { category, subs = [] } = rowData;

  if (searchCaseInsensitive(category, term)) {
    return true;
  }

  return searchInSubs(subs, term);
}

function searchInSubs(subs, term) {
  return subs.reduce((arr, sub) => {
    const {
      name: elName,
      description,
      status,
      activationDate,
      expiryDate
    } = sub;

    const values = [elName, description, status, activationDate, expiryDate];

    const searched = values
      .map(value => searchCaseInsensitive(value, term))
      .filter(value => value);

    return searched.length > 0 ? [...arr, true] : arr;
  }, []).length > 0
    ? true
    : false;
}

export function findSkuTranslation({ rowData, lang }) {
  const { translations } = rowData;

  if (isUndefined(translations)) {
    return '';
  }

  const { sku } = translations;

  if (isDefined(sku) && isObject(sku)) {
    return Optional(sku[lang]).or(Optional(sku.default).or(''));
  }

  return '';
}

export const countFilters = filters => {
  let count = 0;
  if (isStringDefined(filters.search)) {
    count += 1;
  }
  if (filters.status.length > 0) {
    count += filters.status.length;
  }
  if (filters.product.length > 0) {
    count += filters.product.length;
  }
  if (filters.groupedBy.length > 0) {
    count += filters.groupedBy.length;
  }
  return count;
};

export const countQuantity = data => {
  return data.reduce((acc, item) => {
    if (item.quantity) {
      return acc + item.quantity;
    }
    return acc + 1;
  }, 0);
};
